// Common components for reuse

// ConfirmationDialog.js
import React from 'react';

const ConfirmationDialog = ({
                                title,
                                message,
                                confirmLabel,
                                cancelLabel,
                                onConfirm,
                                onCancel,
                                danger = false
                            }) => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full m-4 selection-bar-appear">
                <h3 className="text-lg font-medium text-gray-900 mb-4">{title}</h3>
                <p className="text-sm text-gray-500">{message}</p>
                <div className="mt-6 flex justify-end space-x-3">
                    <button
                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none"
                        onClick={onCancel}
                    >
                        {cancelLabel}
                    </button>
                    <button
                        className={`px-4 py-2 text-sm font-medium text-white rounded-md focus:outline-none
                            ${danger ? 'bg-red-600 hover:bg-red-700' : 'bg-primary hover:bg-primary-dark'}`}
                        onClick={onConfirm}
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationDialog;
